// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"11103820","770":"b0caadcb"}[chunkId] + ".chunk.css";
};